<template>
    <div>
        <sparator v-show="showSparatorButton"></sparator>
        <div class="relative overflow-hidden">
            <picture class="z-0 w-full">
                <source
                    media="(max-width: 768px)"
                    srcset="storage/pages/home/bg-landing-page-mobile.png"
                />
                <img
                    src="storage/pages/home/bg-landing-page.png"
                    alt=""
                    class="w-full"
                />
            </picture>
            <div
                class="absolute top-0 left-0 z-10 flex items-center w-full h-full md:items-start pt-120"
            >
                <div
                    class="flex items-center justify-between w-full mx-150 md:mx-50 md:flex-col"
                >
                    <div class="font-semibold text-white text-40">
                        Growing Better Parents to
                    </div>
                    <div class="font-semibold text-white text-40">
                        Grow Better Generation
                        <span class="text-5xl text-green-500">.</span>
                    </div>
                </div>
            </div>
            <div
                class="absolute bottom-0 z-20 flex justify-center w-full mb-100"
            >
                <inertia-link
                    @click="toggleShowButton"
                    :href="route('donate.index')"
                    :class="this.$css.button"
                >
                    BE OUR DONATOR</inertia-link
                >
            </div>
        </div>
        <div class="relative h-screen">
            <div class="relative z-0 w-full h-full">
                <youtube
                    video-id="jKvWbzRx2fM"
                    :player-vars="{ controls: 0, rel: 0 }"
                    ref="ytpurpose"
                    class="w-full h-full"
                ></youtube>
            </div>
            <div
                class="absolute top-0 left-0 z-10 w-full h-full"
                v-if="thumbnailPurposeActive"
            >
                <img
                    src="storage/pages/home/bg-video.jpg"
                    alt="bg-video"
                    class="absolute top-0 left-0 z-0 object-cover w-full h-full"
                />
                <div
                    class="relative z-10 flex items-end justify-end h-full mx-150 md:mx-50 md:items-center md:justify-center py-150"
                >
                    <div
                        class="inline-flex items-center cursor-pointer"
                        @click="playVideoPurpose"
                    >
                        <div
                            class="flex items-center justify-center bg-white rounded-full w-100 h-100"
                        >
                            <icon
                                name="play"
                                class="ml-10 text-gray-700 w-50 h-50 fill-gray-700"
                            />
                        </div>
                        <div class="text-white text-20 ml-15 md:hidden">
                            Watch our purpose
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="mx-150 md:mx-50 py-150">
                <div :class="this.$css.title">
                    Who We Are <span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="flex md:flex-col-reverse">
                    <div class="flex-none w-9/12 md:w-full pr-500 md:pr-0">
                        <p class="mb-20 text-gray-600 text-25">
                            Parenting, as one of the toughest job in the world,
                            doesn't come with proper onboarding, instructional
                            manual or guidance.
                        </p>
                        <p class="mb-20 text-gray-600 text-25">
                            Today's source of parenting knowledge does not meet
                            current parents' busy and social-media-centered
                            lifestyle. The lack of 'easy & enjoyable' experience
                            is making its reach and shareability low.
                        </p>
                    </div>
                    <div class="flex-1 md:mb-50">
                        <div class="w-7/12 mb-30">
                            <img src="storage/pages/home/people.png" alt="" />
                        </div>
                        <div class="text-gray-600 text-20">
                            Not merely avoiding a problematic<br />adulthood, a
                            lot of kids lose the<br />potential of being their
                            best self<br />because they are not raised right.
                        </div>
                    </div>
                </div>
                <div class="text-center mt-35">
                    <inertia-link
                        @click="toggleShowButton"
                        :href="route('whoweare.index')"
                        :class="this.$css.button"
                    >
                        LEARN MORE</inertia-link
                    >
                </div>
            </div>
        </div>
        <div class="overflow-hidden bg-full-black">
            <div class="py-150">
                <div class="mx-150 md:mx-50">
                    <div :class="this.$css.title" class="text-white">
                        Most Popular Videos<span :class="this.$css.titleGreen"
                            >.</span
                        >
                    </div>
                </div>
                <div class="relative overflow-hidden px-150 ">
                    <div
                        class="absolute inset-y-0 left-0 flex items-center justify-center pl-10"
                        @click="slickPopularVideos.prev()"
                    >
                        <icon
                            name="arrow-left"
                            class="text-white w-100 h-100"
                        />
                    </div>
                    <div
                        class="absolute inset-y-0 right-0 flex items-center justify-center pr-10"
                        @click="slickPopularVideos.next()"
                    >
                        <icon
                            name="arrow-right"
                            class="text-white w-100 h-100"
                        />
                    </div>
                    <slick
                        class="flex -mx-15"
                        ref="popularVideos"
                        :options="popularVideosSlick"
                    >
                        <div
                            class="flex-none w-500 px-15"
                            v-for="popularVideo in popularVideos"
                            :key="popularVideo.youtubeId"
                        >
                            <div class="mb-10 h-300">
                                <youtube
                                    :video-id="popularVideo.youtubeId"
                                    :player-vars="{ controls: 0, rel: 0 }"
                                    :ref="'yt' + popularVideo.youtubeId"
                                    class="w-full h-full"
                                ></youtube>
                            </div>
                            <div class="mb-10 font-semibold text-white text-35">
                                {{ popularVideo.title }}
                            </div>
                            <div class="text-white text-15">
                                by {{ popularVideo.by }}
                            </div>
                        </div>
                    </slick>
                </div>
            </div>
        </div>
        <div class="">
            <div class="py-150 mx-150 md:mx-50">
                <div :class="this.$css.title">
                    Where We Are Today<span :class="this.$css.titleGreen"
                        >.</span
                    >
                </div>
                <div>
                    <div
                        class="relative flex items-end border-b-2 border-gray-500 md:flex-col-reverse md:items-center mb-50 pb-50"
                        v-for="whereWeAreToday in whereWeAreTodays"
                        :key="whereWeAreToday.number"
                    >
                        <div
                            class="font-medium leading-none text-green-500 text-220"
                        >
                            {{ whereWeAreToday.number }}
                        </div>
                        <div
                            class="font-medium text-80 ml-50 md:ml-0 md:text-center"
                        >
                            {{ whereWeAreToday.title }}
                        </div>
                        <div class="flex-1">
                            <div
                                class="flex items-center justify-center ml-auto bg-green-500 rounded-full mb-35 w-100 h-100 "
                            >
                                <icon
                                    :name="whereWeAreToday.icon"
                                    class="w-5/12 h-auto "
                                    :class="
                                        whereWeAreToday.icon != 'instagram'
                                            ? 'fill-white stroke-0'
                                            : 'text-white'
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import popularVideos from "@/Plugins/data/popular-videos";
import whereWeAreTodays from "@/Plugins/data/where-we-are-todays";
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import Youtube from "vue-youtube";
import Slick from "vue-slick";
import Sparator from "../../../components/Sparator.vue";

Vue.use(Youtube);
export default {
    metaInfo() {
        return {
            title: this.head.title
        };
    },
    layout: Layout,
    components: {
        Icon,
        Slick,
        Sparator
    },
    props: {
        head: Object
    },
    data() {
        return {
            showSparatorButton: false,
            thumbnailPurposeActive: true,
            popularVideos: [...popularVideos],
            whereWeAreTodays: [...whereWeAreTodays],
            popularVideosSlick: {
                slidesToShow: 3,
                arrows: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            infinite: false
                        }
                    }
                ]
            }
        };
    },
    computed: {
        playerPurpose() {
            return this.$refs.ytpurpose.player;
        },
        slickPopularVideos() {
            return this.$refs.popularVideos;
        }
    },
    methods: {
        toggleShowButton() {
            this.showSparatorButton = true;
        },
        playVideoPurpose() {
            (this.thumbnailPurposeActive = false),
                this.playerPurpose.playVideo();
        }
    },
    mounted() {}
};
</script>
